import { ActionHub } from "applesauce-actions";
import { kinds } from "nostr-tools";
import { getOutboxes } from "applesauce-core/helpers";

import { eventStore } from "./event-store";
import { writeEvent } from "./event-cache";
import factory from "./event-factory";
import pool from "./pool";

const actions = new ActionHub(eventStore, factory, async (event, relays) => {
  const mailboxes = eventStore.getReplaceable(kinds.RelayList, event.pubkey);
  const outboxes = mailboxes && getOutboxes(mailboxes);

  // Merge outboxes with action-provided relays, fall back to relays if no outboxes
  const targetRelays = outboxes
    ? [...new Set([...outboxes, ...(relays ?? [])])]
    : relays;

  if (!targetRelays || targetRelays.length === 0)
    throw new Error("No relays available for publishing");

  // persist to in-memory store and local cache (IndexedDB)
  eventStore.add(event);
  writeEvent(event);

  pool.publish(targetRelays, event);
});

export default actions;
